// ============================================================
// BOSCO — Script de la page de connexion
// Envoie le formulaire via fetch() et gère les erreurs
// ============================================================

// Helper i18n : retombe sur le fallback FR si la clé manque ou si window.traduire
// n'est pas encore chargé (cas peu probable mais pas catastrophique).
const t = (cle, fallback) => (window.traduire && window.traduire(cle, fallback)) || fallback;

const formulaire = document.getElementById('formulaire-connexion');
const messageErreur = document.getElementById('message-erreur');
const champPassword = document.getElementById('password');
const boutonToggle = document.getElementById('toggle-password');

// --- Toggle afficher/masquer le mot de passe ---
boutonToggle.addEventListener('click', () => {
    const estMasque = champPassword.type === 'password';

    // Bascule le type du champ et adapte le placeholder
    champPassword.type = estMasque ? 'text' : 'password';
    champPassword.placeholder = estMasque ? '' : '••••••••';

    // Met à jour l'icône et le label accessible
    boutonToggle.textContent = estMasque ? '🙈' : '👁';
    boutonToggle.setAttribute(
        'aria-label',
        estMasque
            ? t('BOSCO.Commun.MdpMasquer', 'Masquer le mot de passe')
            : t('BOSCO.Commun.MdpAfficher', 'Afficher le mot de passe'),
    );
});

// Affiche un message d'erreur sous le formulaire
function afficherErreur(message) {
    messageErreur.textContent = message;
    messageErreur.classList.add('visible');
}

// Cache le message d'erreur
function cacherErreur() {
    messageErreur.classList.remove('visible');
}

// Interception de la soumission du formulaire
formulaire.addEventListener('submit', async (evenement) => {
    // Empêche le rechargement de page (comportement par défaut des formulaires)
    evenement.preventDefault();
    cacherErreur();

    // Désactive le bouton pendant la requête pour éviter les soumissions multiples.
    // Spinner CSS in-button (UI-D2) si le helper toasts.js est chargé.
    const boutonSubmit = formulaire.querySelector('button[type="submit"]');
    boutonSubmit.disabled = true;
    if (typeof window.marquerBoutonChargement === 'function') {
        window.marquerBoutonChargement(boutonSubmit, true);
    }

    const username = document.getElementById('username').value.trim();
    const password = document.getElementById('password').value;

    try {
        // Envoie les identifiants au serveur en JSON
        const reponse = await fetch('/api/login', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, password }),
        });

        const donnees = await reponse.json();

        if (reponse.ok && donnees.succes) {
            // Connexion réussie → redirige vers le tableau de bord (bouton reste désactivé)
            window.location.href = donnees.redirection;
        } else {
            // Le serveur a renvoyé une erreur (mauvais identifiants, etc.)
            afficherErreur(donnees.erreur || t('BOSCO.Login.ErreurIdentifiants', 'Identifiants incorrects.'));
            boutonSubmit.disabled = false; // Réactive pour permettre une nouvelle tentative
            if (typeof window.marquerBoutonChargement === 'function') {
                window.marquerBoutonChargement(boutonSubmit, false);
            }
        }
    } catch (erreur) {
        // Erreur réseau ou serveur inaccessible
        afficherErreur(
            t(
                'BOSCO.Commun.ImpossibleContacterServeurReessayer',
                'Impossible de contacter le serveur. Réessaie plus tard.',
            ),
        );
        boutonSubmit.disabled = false;
        if (typeof window.marquerBoutonChargement === 'function') {
            window.marquerBoutonChargement(boutonSubmit, false);
        }
    }
});

// ============================================================
// MOD-P4-B4 — Connexion par lien magique
// MOD-P4-B5 — Mot de passe oublié
// ============================================================
const formulaireMagic = document.getElementById('formulaire-magic');
const formulaireOubli = document.getElementById('formulaire-oubli');
const basculeMagic = document.getElementById('bascule-magic');
const basculeOubli = document.getElementById('bascule-oubli');
const retourMdp = document.getElementById('retour-mdp');
const retourMdpOubli = document.getElementById('retour-mdp-oubli');
const messageMagic = document.getElementById('message-magic');
const messageOubli = document.getElementById('message-oubli');

// Affiche un seul des trois formulaires : 'mdp' | 'magic' | 'oubli'.
function afficherFormulaire(cible) {
    formulaire.hidden = cible !== 'mdp';
    formulaireMagic.hidden = cible !== 'magic';
    formulaireOubli.hidden = cible !== 'oubli';
    if (cible === 'magic') {
        document.getElementById('magic-email').focus();
    } else if (cible === 'oubli') {
        document.getElementById('oubli-email').focus();
    } else {
        document.getElementById('username').focus();
    }
}

basculeMagic.addEventListener('click', () => afficherFormulaire('magic'));
basculeOubli.addEventListener('click', () => afficherFormulaire('oubli'));
retourMdp.addEventListener('click', () => afficherFormulaire('mdp'));
retourMdpOubli.addEventListener('click', () => afficherFormulaire('mdp'));

// Si on revient d'un lien magique invalide/expiré (?erreur=lien), on révèle
// le formulaire email et on affiche le message d'erreur.
if (new URLSearchParams(window.location.search).get('erreur') === 'lien') {
    afficherFormulaire('magic');
    messageMagic.textContent = t('BOSCO.Login.ErreurLienMagique', 'Lien de connexion invalide ou expiré. Réessayez.');
    messageMagic.classList.add('visible');
}

formulaireMagic.addEventListener('submit', async (evenement) => {
    evenement.preventDefault();
    messageMagic.classList.remove('visible');

    const boutonMagic = formulaireMagic.querySelector('button[type="submit"]');
    boutonMagic.disabled = true;
    if (typeof window.marquerBoutonChargement === 'function') {
        window.marquerBoutonChargement(boutonMagic, true);
    }

    const email = document.getElementById('magic-email').value.trim();

    try {
        // Le wrapper csrf.js injecte automatiquement x-csrf-token.
        const reponse = await fetch('/api/login/magic', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email }),
        });
        const donnees = await reponse.json().catch(() => ({}));

        // Réponse toujours générique côté serveur (anti-énumération) : on
        // affiche le message tel quel, succès comme email inconnu.
        messageMagic.textContent =
            donnees.message ||
            t(
                'BOSCO.Login.LienMagiqueEnvoye',
                "Si un compte correspond à cette adresse, un lien vient d'être envoyé. Vérifiez votre boîte mail.",
            );
        messageMagic.classList.add('visible');
    } catch (erreur) {
        messageMagic.textContent = t(
            'BOSCO.Commun.ImpossibleContacterServeurReessayer',
            'Impossible de contacter le serveur. Réessaie plus tard.',
        );
        messageMagic.classList.add('visible');
    } finally {
        boutonMagic.disabled = false;
        if (typeof window.marquerBoutonChargement === 'function') {
            window.marquerBoutonChargement(boutonMagic, false);
        }
    }
});

// MOD-P4-B5 : demande de lien de réinitialisation. Même mécanique que le
// formulaire magic : réponse serveur toujours générique (anti-énumération).
formulaireOubli.addEventListener('submit', async (evenement) => {
    evenement.preventDefault();
    messageOubli.classList.remove('visible');

    const boutonOubli = formulaireOubli.querySelector('button[type="submit"]');
    boutonOubli.disabled = true;
    if (typeof window.marquerBoutonChargement === 'function') {
        window.marquerBoutonChargement(boutonOubli, true);
    }

    const email = document.getElementById('oubli-email').value.trim();

    try {
        // Le wrapper csrf.js injecte automatiquement x-csrf-token.
        const reponse = await fetch('/api/mot-de-passe/oublie', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email }),
        });
        const donnees = await reponse.json().catch(() => ({}));

        messageOubli.textContent =
            donnees.message ||
            t(
                'BOSCO.Login.MdpOublieEnvoye',
                "Si un compte correspond à cette adresse, un lien de réinitialisation vient d'être envoyé. Vérifiez votre boîte mail.",
            );
        messageOubli.classList.add('visible');
    } catch (erreur) {
        messageOubli.textContent = t(
            'BOSCO.Commun.ImpossibleContacterServeurReessayer',
            'Impossible de contacter le serveur. Réessaie plus tard.',
        );
        messageOubli.classList.add('visible');
    } finally {
        boutonOubli.disabled = false;
        if (typeof window.marquerBoutonChargement === 'function') {
            window.marquerBoutonChargement(boutonOubli, false);
        }
    }
});
